import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Author extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: (
                      <> 
                        Based on <a href="https://ieeexplore.ieee.org/document/10491253" target="_blank" rel="noopener noreferrer">IEEE</a> actual researchs
                      </>
                    ), // Título con enlace
                  },
                /*{
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Very passionate about research',
                },*/
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: ' Most Popular writter in the year',
                },
            ]
        }
    }
    render() {
        return (
            <section className="author-section section-padding bg-white" id="author">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">About the author</h3>
                                <p>This book is concerned with the most famous real-world challenges.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="auhtor-img mb-4 mb-lg-0">
                                 <img src="assets/images/bg/author.jpg" alt="" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 ps-4">
                            <div className="section-heading mb-0">
                                <h3 className="heading-title">C.A.L Segura</h3>
                                <p className="lead">My name is César A. López S. I am a professional with experience in engineering. I specialize in creating solutions that meet the needs of businesses and individuals alike, ensuring excellence in everything I do.</p>
                                <p>This well-crafted and insightful book explores the principles of adaptive control, offering essential knowledge for professionals and researchers eager to understand and apply these advanced techniques in dynamic and complex systems.</p>
                            </div>

                            <div className="author-desc">
                                <ul className="list-unstyled">
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={data.id}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                                <p>Reach Me on {/*<Link to="#">Twiiter</Link> or <Link to="#">Facebook</Link> or*/} <Link to="https://www.linkedin.com/in/calopezsegura/">Linkedin</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        );
    }
}

export default Author;
